/* eslint-disable prettier/prettier */
import React, { useCallback, useContext, useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import cs from "classnames";
import { APPLICATION_ROUTES } from "../../../../../../../constants";
import { StoreContext } from "../../../../../../../contexts";
import Braintree from "./components/Braintree";
import Zelle from "../Zelle";
import Modal from "../../../../../../organisms/Modal";
import Icon, { NAMES } from "../../../../../../atoms/Icon";
import SignInPage from "../../../../../SignInPage";
import classes from "./Gateway.module.scss";

const Gateway = observer(({ pledgeDonation }) => {
  const { paymentmethod, checkout, common } = useContext(StoreContext);

  const isDonation =
    common.get("options") === "donation_monthly" ||
    common.get("options") === "donation_yearly" ||
    common.get("options") === "donation" ||
    common.get("options") === "donation_monthly_pledge";

  const onNavigateToThankYou = useCallback(() => {
    if (isDonation) {
      window.location = APPLICATION_ROUTES.DONATION_SUCCESS;
    } else {
      window.location = APPLICATION_ROUTES.PARTNERS_SUCCESS;
    }
  }, []);

  const {
    i18n: { language },
  } = useTranslation();

  const onInitialize = useCallback((...args) => {
    checkout.initialize(...args);
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const isAuthorize = common.get("isAuthorize");

  useEffect(() => {
    paymentmethod.get({});
  }, []);

  const isDonationCheck =
    pledgeDonation ||
    isDonation ||
    window.location.search.includes("from=donation") ||
    window.location.search.includes("page=donation") ||
    window.location.search.includes("page=pledge");

  const isZelleAvailable = isDonationCheck && checkout.zelleConfig?.enabled;
  const isZelleSelected = isZelleAvailable && checkout.selectedPaymentMethod === "zelle";

  const handleCloseZelleModal = () => {
    const isSubmitted =
      checkout.zelleStep === "submitted" ||
      checkout.zelleData?.status === "submitted" ||
      checkout.zelleData?.status === "pending_zelle_verification";

    if (isSubmitted) {
      const targetUrl = APPLICATION_ROUTES.HOME || "/";
      window.location.href = targetUrl;
    } else {
      checkout.setValue("selectedPaymentMethod", "braintree");
    }
  };

  return (
    <>
      {!isAuthorize && (
        <p>
          {paymentmethod.items.length == 0 ? <>Choose a way to pay</> : ""}
          {!isDonation && paymentmethod.items.length > 0 && (
            <span>
              <u
                style={{
                  color: "#FF8A34",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >Authorize</u> {isModalOpen}
              to use your saved payment method.
            </span>
          )}
        </p>
      )}

      <Modal opened={isModalOpen}>
        <div className={classes.wrapper}>
          <div className={classes.card}>
            <span className={classes.close}>
              <Icon
                name={NAMES.X}
                className={classes.crossStyle}
                onClick={() => setIsModalOpen(false)}
              />
            </span>
            <SignInPage
              reauthenticate={true}
              setClosePopUp={setIsModalOpen}
              partnersCheckout={true}
            />
          </div>
        </div>
      </Modal>

      <div
        onClick={() => {
          if (isZelleSelected) {
            checkout.setValue("selectedPaymentMethod", "braintree");
          }
        }}
      >
        <Braintree
          locale={language}
          onInitialize={onInitialize}
          onSaleSuccess={onNavigateToThankYou}
        />
      </div>

      {isZelleAvailable && (
        <>
          <div className={classes.divider}>
            <span> or </span>
          </div>

          <div
            className={cs(
              classes.zelleCard,
              isZelleSelected && classes.zelleCardSelected
            )}
            onClick={() => {
              if (isZelleSelected) {
                checkout.setValue("selectedPaymentMethod", "braintree");
              } else {
                checkout.setValue("selectedPaymentMethod", "zelle");
              }
            }}
          >
            <div className={classes.zelleLeft}>
              <div className={classes.zelleIconBox}>z</div>
              <span className={classes.zelleName}>Zelle</span>
              <span className={classes.manualBadge}>Manual verify</span>
            </div>

            <div
              className={cs(
                classes.radioCircle,
                isZelleSelected && classes.radioCircleSelected
              )}
            />
          </div>

          <Modal
            opened={isZelleSelected}
            onClose={handleCloseZelleModal}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "1.5rem",
              minHeight: "100vh",
            }}
          >
            <div className={classes.zelleModalWrapper}>
              <Zelle onClose={handleCloseZelleModal} />
            </div>
          </Modal>
        </>
      )}
    </>
  );
});

export default Gateway;
